// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentItem_list-products-column__xTFCN {
  width: 60%;
  align-items: flex-start;
}
.PaymentItem_list-products-column__xTFCN p {
  margin-bottom: 0px;
}

.PaymentItem_quantity-price__C2\\+hZ {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 40%;
}

.PaymentItem_quantity-column__Y3evy {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #f2f2f2;
}

.PaymentItem_price-column__OSihI {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.PaymentItem_detail-delete-container__UWDqj {
  margin-bottom: 10px;
}
.PaymentItem_detail-delete-container__UWDqj .PaymentItem_detail__828Wr {
  font-size: 12px;
  color: #808080;
  flex-wrap: wrap;
  margin-right: 20px;
}
.PaymentItem_detail-delete-container__UWDqj .PaymentItem_detail__828Wr p {
  margin-top: 5px;
}
.PaymentItem_detail-delete-container__UWDqj .PaymentItem_icon__IZb-W {
  font-size: 16px;
}
.PaymentItem_detail-delete-container__UWDqj .PaymentItem_delete__YHAsW {
  margin-top: auto;
}
.PaymentItem_detail-delete-container__UWDqj .PaymentItem_delete__YHAsW Button {
  padding-bottom: 0;
  font-size: 16px;
}

.PaymentItem_check-divider__sBSaz {
  margin: 0px -15px;
}

.PaymentItem_flex-space-between__oXSIJ {
  display: flex;
  justify-content: space-between;
}

.PaymentItem_characteristics__XXlFJ {
  padding-right: 5px;
  border-right: 1px solid rgb(174, 176, 174);
}`, "",{"version":3,"sources":["webpack://./src/views/Payment/PaymentItem/PaymentItem.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,UAAA;EACA,uBAAA;AAFF;AAIE;EACE,kBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,UAAA;AAHF;;AAMA;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBCdoB;ADWtB;;AAMA;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;AAKE;EACE,eExCK;EFyCL,cC3BkB;ED8BlB,eAAA;EACA,kBAAA;AAHJ;AAKI;EACE,eAAA;AAHN;AAOE;EACE,eEnDK;AF8CT;AAQE;EACE,gBAAA;AANJ;AAQI;EACE,iBAAA;EACA,eE3DG;AFqDT;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,aAAA;EACA,8BAAA;AARF;;AAWA;EACE,kBAAA;EACA,0CAAA;AARF","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.list-products-column {\n  width: 60%;\n  align-items: flex-start;\n\n  p {\n    margin-bottom: 0px;\n  }\n}\n\n.quantity-price {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 40%;\n}\n\n.quantity-column {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  background-color: colors.$color-background-02;\n}\n\n.price-column {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.detail-delete-container {\n  margin-bottom: 10px;\n\n  .detail {\n    font-size: typography.$body-s;\n    color: colors.$color-text-disabled;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-right: 20px;\n\n    p {\n      margin-top: 5px;\n    }\n  }\n\n  .icon {\n    font-size: typography.$body-l;\n  }\n\n  .delete {\n    margin-top: auto;\n\n    Button {\n      padding-bottom: 0;\n      font-size: typography.$body-l;\n    }\n  }\n}\n\n.check-divider {\n  margin: 0px -15px;\n}\n\n.flex-space-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n.characteristics {\n  padding-right: 5px;\n  border-right: 1px solid rgb(174, 176, 174);\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list-products-column": `PaymentItem_list-products-column__xTFCN`,
	"quantity-price": `PaymentItem_quantity-price__C2+hZ`,
	"quantity-column": `PaymentItem_quantity-column__Y3evy`,
	"price-column": `PaymentItem_price-column__OSihI`,
	"detail-delete-container": `PaymentItem_detail-delete-container__UWDqj`,
	"detail": `PaymentItem_detail__828Wr`,
	"icon": `PaymentItem_icon__IZb-W`,
	"delete": `PaymentItem_delete__YHAsW`,
	"check-divider": `PaymentItem_check-divider__sBSaz`,
	"flex-space-between": `PaymentItem_flex-space-between__oXSIJ`,
	"characteristics": `PaymentItem_characteristics__XXlFJ`
};
export default ___CSS_LOADER_EXPORT___;
